import { openSnackbarAction } from "@icarius-common/snackbar/actions";
import * as actionTypes from "./actionTypes";
import {
  getAllMyTrainingAPI,
  downloadMyTrainingCertificatesAPI,
  getSpecificTrainingAPI,
  getActivityFromTrainingAPI,
  solveActivityFromTrainingAPI,
  getResolutionActivityFromTrainingAPI,
  gradeActivityFromTrainingAPI,
  updateActivityAttemptFromTrainingAPI,
  getTrainingProgressAPI,
  voteQuestionFromTrainingAPI,
  closeQuestionFromTrainingAPI,
  getQuestionAndAnswersFromTrainingAPI,
  createQuestionFromTrainingAPI,
  updateQuestionFromTrainingAPI,
  deleteQuestionFromTrainingAPI,
  createAnswerQuestionFromTrainingAPI,
  updateAnswerQuestionFromTrainingAPI,
  deleteAnswerFromTrainingAPI,
  startActivityFromTrainingAPI,
  getCountdownFromActivityFromTrainingAPI,
  updateNotesFromTrainingAPI,
  getMyTrainingStatsAPI,
  getSpecificTrainingStatsAPI,
} from "@icarius-connection/api";
import { getLocalizedString, getErrorStringFromServerError } from "@icarius-localization/strings";
import { downloadBlob } from "@icarius-utils/download";
import { getFileExtension, getFileName } from "@icarius-utils/fileUpload";

const errorHandler = (e, dispatch) => {
  let errorString = (() => {
    switch (e.response?.data?.status) {
      case "ALREADY_ANSWERED":
        return getLocalizedString("activityAlreadyAnswered");
      case "INCOMPLETE_DEPENDENCY":
        return getLocalizedString("activityDependencyToCompleteFirst", { activityName: e.response.data.name });
      case "INVALID_DATA":
      default: return getErrorStringFromServerError(e);
    }
  })();

  dispatch(openSnackbarAction({ msg: errorString, severity: "error", duration: null }));
}

export const getAllMyTrainingAction = () => async (dispatch) => {
  dispatch({ type: actionTypes.GET_ALL_MY_TRAINING });
  try {
    const response = await getAllMyTrainingAPI();

    const activeList = response.data?.activeList;
    const finishedList = response.data?.finishedList;
    const sessionTypes = response.data?.sessionTypes;
    const canViewStats = response.data?.canViewStats;
    const status = response.data.status;

    if (status !== "OK") {
      dispatch({ type: actionTypes.GET_ALL_MY_TRAINING_REJECTED });
      dispatch(openSnackbarAction({ msg: getLocalizedString("defaultException"), severity: "error" }));
      return;
    }

    dispatch({
      type: actionTypes.GET_ALL_MY_TRAINING_FULFILLED,
      payload: {
        activeList,
        finishedList,
        sessionTypes,
        canViewStats,
      },
    });
    return response;
  } catch (e) {
    dispatch({ type: actionTypes.GET_ALL_MY_TRAINING_REJECTED, payload: e });
    errorHandler(e, dispatch);
    return e.response;
  }
};


export const downloadMyTrainingCertificatesAction = (trainingId) => async (dispatch) => {
  dispatch({ type: actionTypes.DOWNLOAD_MY_TRAINING_CERTIFICATES });
  try {
    let response = await downloadMyTrainingCertificatesAPI(trainingId);
    let title = response.headers["x-content-namefile"];

    if (response.status !== 200) {
      dispatch({ type: actionTypes.DOWNLOAD_MY_TRAINING_CERTIFICATES_REJECTED });
      dispatch(openSnackbarAction({ msg: getLocalizedString("defaultException"), severity: "error" }));
      return;
    }

    dispatch({
      type: actionTypes.DOWNLOAD_MY_TRAINING_CERTIFICATES_FULFILLED,
    });

    downloadBlob(response.data, getFileExtension(title), getFileName(title));
    dispatch(openSnackbarAction({ msg: getLocalizedString("myTrainingCertificatesExportedOk"), severity: "success" }));
    return response;
  } catch (e) {
    dispatch({ type: actionTypes.DOWNLOAD_MY_TRAINING_CERTIFICATES_REJECTED, payload: e });
    errorHandler(e, dispatch);
    return e.response;
  }
};

export const getSpecificTrainingProgressAction = (trainingId) => async (dispatch) => {
  dispatch({ type: actionTypes.GET_SPECIFIC_TRAINING_PROGRESS });
  try {
    const response = await getTrainingProgressAPI(trainingId);

    const participants = response.data.participants;
    const status = response.data.status;

    if (status !== "OK") {
      dispatch({ type: actionTypes.GET_SPECIFIC_TRAINING_PROGRESS_REJECTED });
      dispatch(openSnackbarAction({ msg: getLocalizedString("defaultException"), severity: "error" }));
      return;
    }

    dispatch({
      type: actionTypes.GET_SPECIFIC_TRAINING_PROGRESS_FULFILLED,
      payload: {
        participants,
      },
    });
    return response;
  } catch (e) {
    dispatch({ type: actionTypes.GET_SPECIFIC_TRAINING_PROGRESS_REJECTED, payload: e });
    errorHandler(e, dispatch);
    return e.response;
  }
};

///////////////////////////////////////// execution
export const getSpecificTrainingAction = (trainingId) => async (dispatch) => {
  dispatch({ type: actionTypes.GET_SPECIFIC_TRAINING });
  try {
    const response = await getSpecificTrainingAPI(trainingId);

    const specificTrainingData = response.data;
    const status = response.data.status;

    if (status !== "OK") {
      dispatch({ type: actionTypes.GET_SPECIFIC_TRAINING_REJECTED });
      dispatch(openSnackbarAction({ msg: getLocalizedString("defaultException"), severity: "error" }));
      return;
    }

    dispatch({
      type: actionTypes.GET_SPECIFIC_TRAINING_FULFILLED,
      payload: {
        specificTrainingData,
      },
    });
    return response;
  } catch (e) {
    dispatch({ type: actionTypes.GET_SPECIFIC_TRAINING_REJECTED, payload: e });
    errorHandler(e, dispatch);
    return e.response;
  }
};

export const getActivityFromSpecificTrainingAction = (trainingId, activityId) => async (dispatch) => {
  dispatch({ type: actionTypes.GET_ACTIVITY });
  try {
    const response = await getActivityFromTrainingAPI(trainingId, activityId);

    const activityData = response.data.activity;
    const modules = response.data.modules;
    const status = response.data.status;

    if (status !== "OK") {
      dispatch({ type: actionTypes.GET_ACTIVITY_REJECTED });
      dispatch(openSnackbarAction({ msg: getLocalizedString("defaultException"), severity: "error" }));
      return;
    }

    dispatch({
      type: actionTypes.GET_ACTIVITY_FULFILLED,
      payload: {
        modules,
        activityData,
      },
    });
    return response;
  } catch (e) {
    dispatch({ type: actionTypes.GET_ACTIVITY_REJECTED, payload: e });
    errorHandler(e, dispatch);
    return e.response;
  }
};

export const solveActivityFromSpecificTrainingAction = (trainingId, activityId, data) => async (dispatch) => {
  dispatch({ type: actionTypes.ANSWER_ACTIVITY });
  try {
    const response = await solveActivityFromTrainingAPI(trainingId, activityId, data);

    const activityData = response.data.activity;
    const modules = response.data.modules;
    const status = response.data.status;

    if (status !== "OK") {
      dispatch({ type: actionTypes.ANSWER_ACTIVITY_REJECTED });
      dispatch(openSnackbarAction({ msg: getLocalizedString("defaultException"), severity: "error" }));
      return;
    }

    dispatch({
      type: actionTypes.ANSWER_ACTIVITY_FULFILLED,
      payload: {
        modules,
        activityData,
      },
    });
    dispatch(openSnackbarAction({ msg: getLocalizedString("answerSentSuccessfully"), severity: "success" }));
    return response;
  } catch (e) {
    dispatch({ type: actionTypes.ANSWER_ACTIVITY_REJECTED, payload: e });
    errorHandler(e, dispatch);
    return e.response;
  }
};

export const startActivityFromTrainingAction = (trainingId, activityId) => async (dispatch) => {
  dispatch({ type: actionTypes.START_ACTIVITY });
  try {
    const response = await startActivityFromTrainingAPI(trainingId, activityId);

    const activityData = response.data.activity;
    const modules = response.data.modules;
    const status = response.data.status;

    if (status !== "OK") {
      dispatch({ type: actionTypes.START_ACTIVITY_REJECTED });
      dispatch(openSnackbarAction({ msg: getLocalizedString("defaultException"), severity: "error" }));
      return;
    }

    dispatch({
      type: actionTypes.START_ACTIVITY_FULFILLED,
      payload: {
        modules,
        activityData,
      },
    });
    return response;
  } catch (e) {
    dispatch({ type: actionTypes.START_ACTIVITY_REJECTED, payload: e });
    errorHandler(e, dispatch);
    return e.response;
  }
};

export const getCountdownFromActivityFromTrainingAction = (trainingId, activityId) => async (dispatch) => {
  dispatch({ type: actionTypes.GET_COUNTDOWN_ACTIVITY });
  try {
    const response = await getCountdownFromActivityFromTrainingAPI(trainingId, activityId);

    const countdown = response.data.countdown;
    const status = response.data.status;

    if (status !== "OK") {
      dispatch({ type: actionTypes.GET_COUNTDOWN_ACTIVITY_REJECTED });
      dispatch(openSnackbarAction({ msg: getLocalizedString("defaultException"), severity: "error" }));
      return;
    }

    dispatch({
      type: actionTypes.GET_COUNTDOWN_ACTIVITY_FULFILLED,
      payload: {
        countdown,
      },
    });
    return response;
  } catch (e) {
    dispatch({ type: actionTypes.GET_COUNTDOWN_ACTIVITY_REJECTED, payload: e });
    errorHandler(e, dispatch);
    return e.response;
  }
};

export const getResolutionActivityFromSpecificTrainingAction = (trainingId, activityId, code) => async (dispatch) => {
  dispatch({ type: actionTypes.GET_RESOLUTION });
  try {
    const response = await getResolutionActivityFromTrainingAPI(trainingId, activityId, code);

    const resolutionData = response.data;
    const status = response.data.status;

    if (status !== "OK") {
      dispatch({ type: actionTypes.GET_RESOLUTION_REJECTED });
      dispatch(openSnackbarAction({ msg: getLocalizedString("defaultException"), severity: "error" }));
      return;
    }

    dispatch({
      type: actionTypes.GET_RESOLUTION_FULFILLED,
      payload: {
        resolutionData,
      },
    });
    return response;
  } catch (e) {
    dispatch({ type: actionTypes.GET_RESOLUTION_REJECTED, payload: e });
    errorHandler(e, dispatch);
    return e.response;
  }
};

export const gradeActivityFromSpecificTrainingAction = (trainingId, activityId, code, data) => async (dispatch) => {
  dispatch({ type: actionTypes.GRADE_ACTIVITY });
  try {
    const response = await gradeActivityFromTrainingAPI(trainingId, activityId, code, data);

    const activityData = response.data.activity;
    const modules = response.data.modules;
    const status = response.data.status;

    if (status !== "OK") {
      dispatch({ type: actionTypes.GRADE_ACTIVITY_REJECTED });
      dispatch(openSnackbarAction({ msg: getLocalizedString("defaultException"), severity: "error" }));
      return;
    }

    dispatch({
      type: actionTypes.GRADE_ACTIVITY_FULFILLED,
      payload: {
        modules,
        activityData,
      },
    });
    dispatch(openSnackbarAction({ msg: getLocalizedString("gradeSentSuccessfully"), severity: "success" }));
    return response;
  } catch (e) {
    dispatch({ type: actionTypes.GRADE_ACTIVITY_REJECTED, payload: e });
    errorHandler(e, dispatch);
    return e.response;
  }
};

export const updateActivityAttemptFromSpecificTrainingAction = (trainingId, activityId, code, data) => async (dispatch) => {
  dispatch({ type: actionTypes.UPDATE_ACTIVITY_ATTEMPT });
  try {
    const response = await updateActivityAttemptFromTrainingAPI(trainingId, activityId, code, data);

    const activityData = response.data.activity;
    const modules = response.data.modules;
    const status = response.data.status;

    if (status !== "OK") {
      dispatch({ type: actionTypes.UPDATE_ACTIVITY_ATTEMPT_REJECTED });
      dispatch(openSnackbarAction({ msg: getLocalizedString("defaultException"), severity: "error" }));
      return;
    }

    dispatch({
      type: actionTypes.UPDATE_ACTIVITY_ATTEMPT_FULFILLED,
      payload: {
        modules,
        activityData,
      },
    });
    dispatch(openSnackbarAction({ msg: getLocalizedString("attemptUpdatedSuccessfully"), severity: "success" }));
    return response;
  } catch (e) {
    dispatch({ type: actionTypes.UPDATE_ACTIVITY_ATTEMPT_REJECTED, payload: e });
    errorHandler(e, dispatch);
    return e.response;
  }
};

///////////////////////////////////////// q&a
export const voteQuestionFromTrainingAction = (trainingId, activityId, questionId) => async (dispatch) => {
  dispatch({ type: actionTypes.VOTE_QUESTION });
  try {
    const response = await voteQuestionFromTrainingAPI(trainingId, activityId, questionId);

    const activityData = response.data.activity;
    const modules = response.data.modules;
    const status = response.data.status;

    if (status !== "OK") {
      dispatch({ type: actionTypes.VOTE_QUESTION_REJECTED });
      dispatch(openSnackbarAction({ msg: getLocalizedString("defaultException"), severity: "error" }));
      return;
    }

    dispatch({
      type: actionTypes.VOTE_QUESTION_FULFILLED,
      payload: {
        modules,
        activityData,
      },
    });
    return response;
  } catch (e) {
    dispatch({ type: actionTypes.VOTE_QUESTION_REJECTED, payload: e });
    errorHandler(e, dispatch);
    return e.response;
  }
};

export const closeQuestionFromTrainingAction = (trainingId, activityId, questionId) => async (dispatch) => {
  dispatch({ type: actionTypes.CLOSE_QUESTION });
  try {
    const response = await closeQuestionFromTrainingAPI(trainingId, activityId, questionId);

    const activityData = response.data.activity;
    const modules = response.data.modules;
    const status = response.data.status;

    if (status !== "OK") {
      dispatch({ type: actionTypes.CLOSE_QUESTION_REJECTED });
      dispatch(openSnackbarAction({ msg: getLocalizedString("defaultException"), severity: "error" }));
      return;
    }

    dispatch({
      type: actionTypes.CLOSE_QUESTION_FULFILLED,
      payload: {
        modules,
        activityData,
      },
    });
    dispatch(openSnackbarAction({ msg: getLocalizedString("questionMarkedAsSolvedSuccessfully"), severity: "success" }));
    return response;
  } catch (e) {
    dispatch({ type: actionTypes.CLOSE_QUESTION_REJECTED, payload: e });
    errorHandler(e, dispatch);
    return e.response;
  }
};

export const getQuestionAndAnswersFromTrainingAction = (trainingId, activityId, questionId) => async (dispatch) => {
  dispatch({ type: actionTypes.GET_QUESTION_AND_ANSWERS });
  try {
    const response = await getQuestionAndAnswersFromTrainingAPI(trainingId, activityId, questionId);

    const questionData = response.data.question;
    const status = response.data.status;

    if (status !== "OK") {
      dispatch({ type: actionTypes.GET_QUESTION_AND_ANSWERS_REJECTED });
      dispatch(openSnackbarAction({ msg: getLocalizedString("defaultException"), severity: "error" }));
      return;
    }

    dispatch({
      type: actionTypes.GET_QUESTION_AND_ANSWERS_FULFILLED,
      payload: {
        questionData,
      },
    });
    return response;
  } catch (e) {
    dispatch({ type: actionTypes.GET_QUESTION_AND_ANSWERS_REJECTED, payload: e });
    errorHandler(e, dispatch);
    return e.response;
  }
};

export const createQuestionFromTrainingAction = (trainingId, activityId, data) => async (dispatch) => {
  dispatch({ type: actionTypes.CREATE_QUESTION });
  try {
    const response = await createQuestionFromTrainingAPI(trainingId, activityId, data);

    const activityData = response.data.activity;
    const modules = response.data.modules;
    const status = response.data.status;

    if (status !== "OK") {
      dispatch({ type: actionTypes.CREATE_QUESTION_REJECTED });
      dispatch(openSnackbarAction({ msg: getLocalizedString("defaultException"), severity: "error" }));
      return;
    }

    dispatch({
      type: actionTypes.CREATE_QUESTION_FULFILLED,
      payload: {
        activityData,
        modules,
      },
    });
    dispatch(openSnackbarAction({ msg: getLocalizedString("questionCreatedSuccessfully"), severity: "success" }));
    return response;
  } catch (e) {
    dispatch({ type: actionTypes.CREATE_QUESTION_REJECTED, payload: e });
    errorHandler(e, dispatch);
    return e.response;
  }
};

export const updateQuestionFromTrainingAction = (trainingId, activityId, questionId, data) => async (dispatch) => {
  dispatch({ type: actionTypes.UPDATE_QUESTION });
  try {
    const response = await updateQuestionFromTrainingAPI(trainingId, activityId, questionId, data);

    const activityData = response.data.activity;
    const modules = response.data.modules;
    const status = response.data.status;

    if (status !== "OK") {
      dispatch({ type: actionTypes.UPDATE_QUESTION_REJECTED });
      dispatch(openSnackbarAction({ msg: getLocalizedString("defaultException"), severity: "error" }));
      return;
    }

    dispatch({
      type: actionTypes.UPDATE_QUESTION_FULFILLED,
      payload: {
        activityData,
        modules,
      },
    });
    dispatch(openSnackbarAction({ msg: getLocalizedString("questionUpdatedSuccessfully"), severity: "success" }));
    return response;
  } catch (e) {
    dispatch({ type: actionTypes.UPDATE_QUESTION_REJECTED, payload: e });
    errorHandler(e, dispatch);
    return e.response;
  }
};

export const deleteQuestionFromTrainingAction = (trainingId, activityId, questionId) => async (dispatch) => {
  dispatch({ type: actionTypes.DELETE_QUESTION });
  try {
    const response = await deleteQuestionFromTrainingAPI(trainingId, activityId, questionId);

    const activityData = response.data.activity;
    const modules = response.data.modules;
    const status = response.data.status;

    if (status !== "OK") {
      dispatch({ type: actionTypes.DELETE_QUESTION_REJECTED });
      dispatch(openSnackbarAction({ msg: getLocalizedString("defaultException"), severity: "error" }));
      return;
    }

    dispatch({
      type: actionTypes.DELETE_QUESTION_FULFILLED,
      payload: {
        activityData,
        modules,
      },
    });
    dispatch(openSnackbarAction({ msg: getLocalizedString("questionDeletedSuccessfully"), severity: "success" }));
    return response;
  } catch (e) {
    dispatch({ type: actionTypes.DELETE_QUESTION_REJECTED, payload: e });
    errorHandler(e, dispatch);
    return e.response;
  }
};

export const createAnswerQuestionFromTrainingAction = (trainingId, activityId, questionId, data) => async (dispatch) => {
  dispatch({ type: actionTypes.CREATE_ANSWER });
  try {
    const response = await createAnswerQuestionFromTrainingAPI(trainingId, activityId, questionId, data);

    const activityData = response.data.activity;
    const modules = response.data.modules;
    const questionData = response.data.question;
    const status = response.data.status;

    if (status !== "OK") {
      dispatch({ type: actionTypes.CREATE_ANSWER_REJECTED });
      dispatch(openSnackbarAction({ msg: getLocalizedString("defaultException"), severity: "error" }));
      return;
    }

    dispatch({
      type: actionTypes.CREATE_ANSWER_FULFILLED,
      payload: {
        activityData,
        modules,
        questionData,
      },
    });
    dispatch(openSnackbarAction({ msg: getLocalizedString("answerCreatedSuccessfully"), severity: "success" }));
    return response;
  } catch (e) {
    dispatch({ type: actionTypes.CREATE_ANSWER_REJECTED, payload: e });
    errorHandler(e, dispatch);
    return e.response;
  }
};

export const updateAnswerQuestionFromTrainingAction = (trainingId, activityId, questionId, answerId, data) => async (dispatch) => {
  dispatch({ type: actionTypes.UPDATE_ANSWER });
  try {
    const response = await updateAnswerQuestionFromTrainingAPI(trainingId, activityId, questionId, answerId, data);

    const activityData = response.data.activity;
    const modules = response.data.modules;
    const questionData = response.data.question;
    const status = response.data.status;

    if (status !== "OK") {
      dispatch({ type: actionTypes.UPDATE_ANSWER_REJECTED });
      dispatch(openSnackbarAction({ msg: getLocalizedString("defaultException"), severity: "error" }));
      return;
    }

    dispatch({
      type: actionTypes.UPDATE_ANSWER_FULFILLED,
      payload: {
        activityData,
        modules,
        questionData,
      },
    });
    dispatch(openSnackbarAction({ msg: getLocalizedString("answerUpdatedSuccessfully"), severity: "success" }));
    return response;
  } catch (e) {
    dispatch({ type: actionTypes.UPDATE_ANSWER_REJECTED, payload: e });
    errorHandler(e, dispatch);
    return e.response;
  }
};

export const deleteAnswerFromTrainingAction = (trainingId, activityId, questionId, answerId) => async (dispatch) => {
  dispatch({ type: actionTypes.DELETE_ANSWER });
  try {
    const response = await deleteAnswerFromTrainingAPI(trainingId, activityId, questionId, answerId);

    const activityData = response.data.activity;
    const modules = response.data.modules;
    const questionData = response.data.question;
    const status = response.data.status;

    if (status !== "OK") {
      dispatch({ type: actionTypes.DELETE_ANSWER_REJECTED });
      dispatch(openSnackbarAction({ msg: getLocalizedString("defaultException"), severity: "error" }));
      return;
    }

    dispatch({
      type: actionTypes.DELETE_ANSWER_FULFILLED,
      payload: {
        activityData,
        modules,
        questionData,
      },
    });
    dispatch(openSnackbarAction({ msg: getLocalizedString("answerDeletedSuccessfully"), severity: "success" }));
    return response;
  } catch (e) {
    dispatch({ type: actionTypes.DELETE_ANSWER_REJECTED, payload: e });
    errorHandler(e, dispatch);
    return e.response;
  }
};

export const updateNotesFromTrainingAction = (trainingId, activityId, data) => async (dispatch) => {
  dispatch({ type: actionTypes.UPDATE_NOTE });
  try {
    const response = await updateNotesFromTrainingAPI(trainingId, activityId, data);

    const activityData = response.data.activity;
    const modules = response.data.modules;
    const status = response.data.status;

    if (status !== "OK") {
      dispatch({ type: actionTypes.UPDATE_NOTE_REJECTED });
      dispatch(openSnackbarAction({ msg: getLocalizedString("defaultException"), severity: "error" }));
      return;
    }

    dispatch({
      type: actionTypes.UPDATE_NOTE_FULFILLED,
      payload: {
        activityData,
        modules,
      },
    });
    dispatch(openSnackbarAction({ msg: getLocalizedString("notesUpdatedSuccessfully"), severity: "success" }));
    return response;
  } catch (e) {
    dispatch({ type: actionTypes.UPDATE_NOTE_REJECTED, payload: e });
    errorHandler(e, dispatch);
    return e.response;
  }
};

///////////////////////////////////////// stats
export const getMyTrainingStatsAction = () => async (dispatch) => {
  dispatch({ type: actionTypes.GET_STATS });
  try {
    const response = await getMyTrainingStatsAPI();

    const trainingStats = response.data.trainingStats;
    const participantStats = response.data.participantStats;
    const status = response.data.status;

    if (status !== "OK") {
      dispatch({ type: actionTypes.GET_STATS_REJECTED });
      dispatch(openSnackbarAction({ msg: getLocalizedString("defaultException"), severity: "error" }));
      return;
    }

    dispatch({
      type: actionTypes.GET_STATS_FULFILLED,
      payload: {
        trainingStats,
        participantStats,
      },
    });
    return response;
  } catch (e) {
    dispatch({ type: actionTypes.GET_STATS_REJECTED, payload: e });
    errorHandler(e, dispatch);
    return e.response;
  }
};

export const getSpecificTrainingStatsAction = (trainingId) => async (dispatch) => {
  dispatch({ type: actionTypes.GET_STATS_BY_TRAINING });
  try {
    const response = await getSpecificTrainingStatsAPI(trainingId);

    const specificTrainingStats = response.data.data;
    const status = response.data.status;

    if (status !== "OK") {
      dispatch({ type: actionTypes.GET_STATS_BY_TRAINING_REJECTED });
      dispatch(openSnackbarAction({ msg: getLocalizedString("defaultException"), severity: "error" }));
      return;
    }

    dispatch({
      type: actionTypes.GET_STATS_BY_TRAINING_FULFILLED,
      payload: {
        specificTrainingStats,
      },
    });
    return response;
  } catch (e) {
    dispatch({ type: actionTypes.GET_STATS_BY_TRAINING_REJECTED, payload: e });
    errorHandler(e, dispatch);
    return e.response;
  }
};
